import { AutogenModelDetail401kRate, AutogenRowDetail401kRate } from "./autogen/AutogenModelDetail401kRate";

export class ModelDetail401kRate extends AutogenModelDetail401kRate<RowDetail401kRate> {
	constructor() {
		super(RowDetail401kRate);
	}
}

export class RowDetail401kRate extends AutogenRowDetail401kRate {
}